import { Button, HStack, Text, TextProps } from '@chakra-ui/react'

import { Icon } from '../Icons/Icon'

type NotificationsHeaderProps = TextProps & {
  unreadCounter?: number
  dismissNotifications: () => void
}

export const NotificationsHeader = ({
  unreadCounter = 0,
  dismissNotifications = () => {},
}: NotificationsHeaderProps) => {
  return (
    <HStack
      padding="16px 21px 15px"
      width="100%"
      boxSizing="border-box"
      background="presets.neutral.0"
      color="presets.neutral.0"
      justifyContent="space-between"
      borderBottom="1px solid"
      borderBottomColor="presets.neutral.20"
    >
      <Text
        display="flex"
        alignItems="center"
        height="25px"
        fontFamily="Montserrat"
        fontStyle="normal"
        fontWeight="500"
        fontSize="16px"
        lineHeight="140%"
        letterSpacing=".2px"
        color="presets.turquoise.100"
      >
        Notifications ({unreadCounter})
      </Text>
      <Button
        backgroundColor="presets.neutral.0"
        fontSize="12px"
        fontWeight="700"
        variant="ghost"
        onClick={dismissNotifications}
        color="presets.turquoise.70"
        _hover={{
          backgroundColor: 'presets.neutral.0',
        }}
      >
        <Icon
          icon="DoubleCheckIcon"
          boxSize="20px"
          mr="5px"
          color="presets.turquoise.70"
        />
        Mark All As Read
      </Button>
    </HStack>
  )
}
